import { MarkerRouteIcon } from '@icons';
import { CaseLogisticsMap } from '@lp/features/CaseLogistics/components/CaseLogisticsMap';
import { useRouteMainLocations } from '@lp/features/RoutePlanner/hooks/useRouteMainLocations';
import { useCaseDetails } from '@/hooks/useCaseDetails';
import { Case, CaseFacility, CaseStatus, RoutePlanStatus } from '@/api/apis/case';
import { isAllowedStatus } from '@/utils/helpers';
import { AviaLegTypes, GroundLegTypes } from '@/api/apis/route';

const EMPTY_ARRAY: (AviaLegTypes | GroundLegTypes)[] = [];

export const EmptyLogistics = ({ donorHospital }: { donorHospital?: CaseFacility }) => {
  const { txCenterDetails: txCenter, organType, routePlanningStatus, status } = useCaseDetails() as Case;
  const locations = useRouteMainLocations();

  const isRouteDetailsAllowed = isAllowedStatus({
    statusFrom: CaseStatus.ResourcesBooked,
    statusTo: CaseStatus.Finished,
    currentStatus: status,
  });

  const isRoutePlanningDone =
    routePlanningStatus &&
    [
      RoutePlanStatus.RoutePlanningDone,
      RoutePlanStatus.PendingResourcesBooking,
      RoutePlanStatus.ResourcesBooked,
    ].includes(routePlanningStatus);
  const hasRouteDetails = isRouteDetailsAllowed && !!routePlanningStatus;
  const isRouteDone = (status === CaseStatus.PendingLogistics && isRoutePlanningDone) || hasRouteDetails;

  return (
    <>
      <div className="w-full flex shrink-0 h-50 bg-base-60 rounded-2xl overflow-hidden z-10">
        <CaseLogisticsMap
          donorHospital={donorHospital}
          txCenter={txCenter}
          legs={EMPTY_ARRAY}
          organType={organType}
          isRouteDone={isRouteDone}
          locations={locations}
        />
      </div>
      <div className="flex flex-col flex-1 gap-7 items-center w-full mt-45">
        <MarkerRouteIcon className="text-base-55 size-32.5" />
      </div>
    </>
  );
};
